import * as Sentry from "@sentry/react";

import {
    GetAccountOrgsResponse,
    GetAdminhubAccountOrgsResponse
} from "@/libraries/bxp-web-stargate-client/src";

import { SENTRY_PROJECT_NAME } from "../constants";

import type { FastShiftState } from "./reducer";

// accountOrgs contains active and inactive orgs (due to a server-side bug)
// adminhubAccountOrgs contains only active orgs, but not whether the user is an org admin
// we can find active orgs while preserving org admin field by returning common items
export const filterForActiveOrgs = (
    accountOrgs: GetAccountOrgsResponse["accountOrgs"],
    adminhubAccountOrgs: GetAdminhubAccountOrgsResponse["accountOrgs"]
): GetAccountOrgsResponse["accountOrgs"] => {
    if (!accountOrgs || !adminhubAccountOrgs) {
        return [];
    }

    const mergedAccountOrgs = accountOrgs.filter((org) => {
        return adminhubAccountOrgs?.find(
            (adminhubOrg) => adminhubOrg.id === org.id
        );
    });

    return mergedAccountOrgs;
};

export const getUserDomain = (state: FastShiftState) => {
    return state.userDetails.data?.userDomain?.domain;
};

export const captureErrorWithContext = ({
    error,
    message,
    userDomain
}: {
    error: string;
    message: string;
    userDomain?: string;
}) => {
    Sentry.captureException(new Error(error), {
        tags: {
            projectName: SENTRY_PROJECT_NAME
        },
        extra: {
            errorMessage: message,
            userDomain: userDomain || ""
        }
    });
};
